/* eslint-disable react/forbid-prop-types */
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ExpandCollapse, Typography } from '@telus-uds/components-web';
import Modal from '../../design/shared/modal';
import { customStyles } from './css';

import UpdateOrder from './updateOrder';
import Note from '../../note';
import FormSummaryGroup from '../../form/formSummaryGroup';

const OrderDetails = ({
  open,
  setOpen,
  order,
  onSave,
  userRights,
  assignees,
  comments,
  summary,
  isSalesManager,
  isSalesSupport,
  isAdmin,
  isSalesRep
}) => {
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      order={order}
      customStyles={customStyles}
      header={_.get(order, 'orderId', '')}
      wide
    >
      <div className="container 85% view-order-summary">
        <UpdateOrder
          order={order}
          setOpen={setOpen}
          open={open}
          onSave={onSave}
          users={assignees}
          userRights={userRights}
          comments={comments}
          isSalesManager={isSalesManager}
          isSalesSupport={isSalesSupport}
          isAdmin={isAdmin}
          isSalesRep={isSalesRep}
          hideQuote
        >
          <ExpandCollapse initialOpen={[]} topDivider={false}>
            {(expandProps) => (
              <>
                {summary &&
                  summary.map(({ fields }) => {
                    const { note, formSummaryGroup, title } = fields;
                    return (
                      <ExpandCollapse.Panel
                        key={title}
                        {...expandProps}
                        panelId={title}
                        control={<Typography variant={{ bold: true }}>{title}</Typography>}
                      >
                        <>
                          {note && note.content && (
                            <Note data={note} type="richText" />
                          )}
                          <FormSummaryGroup
                            data={formSummaryGroup}
                            orderData={order}
                          />
                        </>
                      </ExpandCollapse.Panel>
                    );
                  })}
              </>
            )}
          </ExpandCollapse>
        </UpdateOrder>
      </div>
    </Modal>
  );
};

OrderDetails.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  onSave: PropTypes.func,
  userRights: PropTypes.object.isRequired,
  comments: PropTypes.arrayOf(PropTypes.object),
  assignees: PropTypes.object,
  summary: PropTypes.object.isRequired,
  isSalesManager: PropTypes.bool.isRequired,
  isSalesSupport: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  isSalesRep: PropTypes.bool.isRequired
};

OrderDetails.defaultProps = {
  onSave: null,
  assignees: null,
  comments: null
};

export default OrderDetails;
